import React from "react";
import {motion} from "framer-motion";
import {FaWhatsapp} from "react-icons/fa";

const WhatsAppWidget = ({ phoneNumber }) => {
    const handleClick = () => {
        window.open(`https://wa.me/+966112699918`, "_blank");
    };

    return (
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="cp"
            onClick={handleClick}
        >
            <div className="bg-green-500 p-3 whatsapp-icon rounded-full shadow-lg hover:bg-green-600 transition-all">
                <FaWhatsapp className="text-3xl" />
            </div>
        </motion.div>
    );
};

export default WhatsAppWidget;